// ── Built-in SVG icon library ─────────────────────────────────────────────
  const SCROLL_MENU_ICONS = {
    home:     `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 8l7-6 7 6v8a1 1 0 01-1 1H3a1 1 0 01-1-1V8z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M6 17v-6h6v6" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>`,
    users:    `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="7" cy="6" r="3" stroke="currentColor" stroke-width="1.3"/><path d="M1 16c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><path d="M13 9c2.209 0 4 1.791 4 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="13" cy="5.5" r="2.5" stroke="currentColor" stroke-width="1.3"/></svg>`,
    bell:     `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 2a5 5 0 00-5 5v3l-1.5 2.5h13L14 10V7a5 5 0 00-5-5z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M7 15a2 2 0 004 0" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`,
    chart:    `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="2" y="10" width="3" height="6" rx="1" stroke="currentColor" stroke-width="1.3"/><rect x="7.5" y="6" width="3" height="10" rx="1" stroke="currentColor" stroke-width="1.3"/><rect x="13" y="2" width="3" height="14" rx="1" stroke="currentColor" stroke-width="1.3"/></svg>`,
    settings: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="2.5" stroke="currentColor" stroke-width="1.3"/><path d="M9 1v2M9 15v2M1 9h2M15 9h2M3.22 3.22l1.42 1.42M13.36 13.36l1.42 1.42M3.22 14.78l1.42-1.42M13.36 4.64l1.42-1.42" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`,
    wallet:   `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="1" y="5" width="16" height="11" rx="2" stroke="currentColor" stroke-width="1.3"/><path d="M1 8h16M5 5V3a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="13.5" cy="11.5" r="1" fill="currentColor"/></svg>`,
    msg:      `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 3h14a1 1 0 011 1v8a1 1 0 01-1 1H5l-4 3V4a1 1 0 011-1z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>`,
    shield:   `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 1l7 3v5c0 4-3.5 7-7 8-3.5-1-7-4-7-8V4l7-3z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>`,
    map:      `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1 4l5 2 6-3 5 2v11l-5-2-6 3-5-2V4z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M6 6v9M12 3v9" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`,
    calendar: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="1" y="3" width="16" height="14" rx="2" stroke="currentColor" stroke-width="1.3"/><path d="M1 8h16M6 1v4M12 1v4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`,
    tag:      `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.5 1H3a2 2 0 00-2 2v6.5a1 1 0 00.3.7l7.5 7.5a2 2 0 002.8 0l5.7-5.7a2 2 0 000-2.8L9.5 1z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><circle cx="5.5" cy="6.5" r="1.5" fill="currentColor"/></svg>`,
    lock:     `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="3" y="8" width="12" height="9" rx="2" stroke="currentColor" stroke-width="1.3"/><path d="M6 8V5a3 3 0 016 0v3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`,
  };
 
  class ScrollMenu extends HTMLElement {
 
    // ── A. Shadow DOM setup ──────────────────────────────────────────────
    constructor() {
      super();
      this._shadow   = this.attachShadow({ mode: "open" });
      this._items    = [];
      this._activeId = null;
      this._variant  = "icons"; // "icons" | "text"
    }
 
    // ── B. Lifecycle ─────────────────────────────────────────────────────
    connectedCallback() {
      this._variant = this.getAttribute("variant") === "text" ? "text" : "icons";
      this._render();
      this._bindArrows();
      this._syncArrows();
    }
 
    // ── C. JS property setter ────────────────────────────────────────────
    set items(data) {
      this._items    = Array.isArray(data) ? data : [];
      this._activeId = this._items.length ? this._items[0].id : null;
      this._renderItems();
      this._syncArrows();
    }
 
    // ── D. Attribute → property bridge ───────────────────────────────────
    static get observedAttributes() { return ["items"]; }
    attributeChangedCallback(name, _, newVal) {
      if (name === "items") {
        try { this.items = JSON.parse(newVal); } catch {}
      }
    }
 
    // ── E. Update a single item's badge count at runtime ─────────────────
    setBadge(id, count) {
      const item = this._items.find(i => i.id === id);
      if (item) {
        item.badge = count;
        this._renderItems();
      }
    }
 
    // ── F. Programmatically activate an item ─────────────────────────────
    setActive(id) {
      if (!this._items.find(i => i.id === id)) return;
      this._activeId = id;
      this._renderItems();
      const el = this._shadow.querySelector(`[data-id="${id}"]`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
    }
 
    // ── G. Build HTML for a single item ──────────────────────────────────
    _itemHTML(item) {
      const isActive  = item.id === this._activeId;
      const badgeHTML = item.badge
        ? `<span class="badge">${item.badge > 99 ? "99+" : item.badge > 9 ? "9+" : item.badge}</span>`
        : "";
      const iconHTML  = this._variant === "icons" && SCROLL_MENU_ICONS[item.icon]
        ? `<div class="icon-wrap"><div class="icon">${SCROLL_MENU_ICONS[item.icon]}</div>${badgeHTML}</div>`
        : (this._variant === "icons" ? `<div class="icon-wrap"><div class="icon"></div>${badgeHTML}</div>` : "");
 
      return `<div class="item${isActive ? " active" : ""}" data-id="${item.id}"
                   role="tab" tabindex="0" aria-selected="${isActive}">
        ${iconHTML}
        <span class="label">${item.label}</span>
      </div>`;
    }
 
    // ── H. Re-render only the item list ──────────────────────────────────
    _renderItems() {
      const track = this._shadow.getElementById("track");
      if (!track) return;
      track.innerHTML = this._items.map(i => this._itemHTML(i)).join("");
      track.querySelectorAll(".item").forEach(el => {
        el.addEventListener("click", () => this._selectItem(el.dataset.id));
        el.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") this._selectItem(el.dataset.id);
          if (e.key === "ArrowRight") this._moveFocus(el, 1);
          if (e.key === "ArrowLeft")  this._moveFocus(el, -1);
        });
      });
    }
 
    // ── I. Move keyboard focus to adjacent item ───────────────────────────
    _moveFocus(el, dir) {
      const items = [...this._shadow.querySelectorAll(".item")];
      const idx   = items.indexOf(el);
      const next  = items[idx + dir];
      if (next) { next.focus(); next.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" }); }
    }
 
    // ── J. Select an item, update state, fire event ───────────────────────
    _selectItem(id) {
      this._activeId = id;
      this._renderItems();
      const el = this._shadow.querySelector(`[data-id="${id}"]`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
      const item = this._items.find(i => i.id === id);
      if (item) {
        this.dispatchEvent(new CustomEvent("menu-select", {
          detail: item, bubbles: true, composed: true
        }));
      }
    }
 
    // ── K. Arrow button logic + fade overlay opacity ──────────────────────
    _bindArrows() {
      const track = this._shadow.getElementById("track");
      const prev  = this._shadow.getElementById("prev");
      const next  = this._shadow.getElementById("next");
      if (!track || !prev || !next) return;
 
      prev.addEventListener("click", () => track.scrollBy({ left: -160, behavior: "smooth" }));
      next.addEventListener("click", () => track.scrollBy({ left:  160, behavior: "smooth" }));
      track.addEventListener("scroll", () => this._syncArrows());
    }
 
    // ── L. Enable / disable arrows and fade overlays ─────────────────────
    _syncArrows() {
      const track = this._shadow.getElementById("track");
      const prev  = this._shadow.getElementById("prev");
      const next  = this._shadow.getElementById("next");
      const fl    = this._shadow.getElementById("fade-left");
      const fr    = this._shadow.getElementById("fade-right");
      if (!track) return;
 
      const atStart = track.scrollLeft <= 2;
      const atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
 
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      if (fl)   fl.style.opacity   = atStart ? "0" : "1";
      if (fr)   fr.style.opacity   = atEnd   ? "0" : "1";
    }
 
    // ── M. Arrow SVGs ────────────────────────────────────────────────────
    _chevronLeft()  { return `<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8l4-4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>`; }
    _chevronRight() { return `<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>`; }
 
    // ── N. Full initial render ────────────────────────────────────────────
    _render() {
      this._shadow.innerHTML = `
        <style>
          *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
 
          :host { display: block; font-family: system-ui, sans-serif; }
 
          .root {
            position: relative;
            display: flex;
            align-items: center;
            background: #fff;
            border: 0.5px solid #e0dfd7;
            border-radius: 12px;
            overflow: hidden;
            color: #fff;
          }
 
          .track-wrap { flex: 1; overflow: hidden; }
 
          .track {
            display: flex;
            align-items: center;
            overflow-x: auto;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            gap: 2px;
            padding: 6px 8px;
          }
          .track::-webkit-scrollbar { display: none; }
 
          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
            padding: 8px 14px;
            border-radius: 8px;
            cursor: pointer;
            white-space: nowrap;
            flex-shrink: 0;
            border: 0.5px solid transparent;
            transition: background 0.12s, border-color 0.12s;
            min-width: 64px;
            user-select: none;
            -webkit-user-select: none;
          }
 
          .item:hover { background: #f5f5f3; border-color: #e0dfd7; }
          .item:focus-visible { outline: 2px solid #4a90d9; outline-offset: 2px; }
 
          .item.active {
            /*background: #1a1a1a;*/
            background: #5D4037;
            border-color: #1a1a1a;
          }
 
          .icon-wrap {
            position: relative;
            width: 22px;
            height: 22px;
          }
 
          .icon {
            width: 22px;
            height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #888;
          }
 
          .item.active .icon { color: #fff; }
 
          .badge {
            position: absolute;
            top: -4px;
            right: -5px;
            min-width: 14px;
            height: 14px;
            border-radius: 99px;
            background: #e24b4a;
            color: #fff;
            font-size: 9px;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 3px;
            line-height: 1;
            border: 1.5px solid #fff;
          }
 
          .label {
            font-size: 11px;
            font-weight: 500;
            color: #888;
          }
 
          .item.active .label { color: #fff; }
 
          .arrow {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            min-height: 52px;
            flex-shrink: 0;
            cursor: pointer;
            color: #888;
            border: none;
            background: #fff;
            transition: color 0.12s, background 0.12s;
            z-index: 2;
          }
 
          .arrow:hover:not(:disabled) { color: #1a1a1a; background: #f5f5f3; }
          .arrow:disabled { color: #ccc; cursor: default; }
          .arrow.left  { border-right: 0.5px solid #e0dfd7; }
          .arrow.right { border-left:  0.5px solid #e0dfd7; }
 
          .fade-left, .fade-right {
            position: absolute;
            top: 0; bottom: 0;
            width: 32px;
            pointer-events: none;
            z-index: 1;
            transition: opacity 0.2s;
          }
 
          .fade-left  { left: 36px;  background: linear-gradient(to right, #fff, transparent); }
          .fade-right { right: 36px; background: linear-gradient(to left,  #fff, transparent); }
 
          /*
          @media (prefers-color-scheme: dark) {
            .root      { background: #1e1e1c; border-color: #333330; }
            .item      { color: #ccc; }
            .item:hover{ background: #2a2a28; border-color: #333330; }
            .item.active { background: #f0ede8; border-color: #f0ede8; }
            .item.active .icon  { color: #1a1a1a; }
            .item.active .label { color: #1a1a1a; }
            .label     { color: #888; }
            .icon      { color: #888; }
            .arrow     { background: #1e1e1c; color: #888; }
            .arrow:hover:not(:disabled) { background: #2a2a28; color: #f0ede8; }
            .arrow.left  { border-right-color: #333330; }
            .arrow.right { border-left-color:  #333330; }
            .fade-left  { background: linear-gradient(to right, #1e1e1c, transparent); }
            .fade-right { background: linear-gradient(to left,  #1e1e1c, transparent); }
            .badge { border-color: #1e1e1c; }
          }
            */
        </style>
 
        <div class="root" role="tablist" aria-label="Navigation menu">
          <button class="arrow left" id="prev" aria-label="Scroll left">${this._chevronLeft()}</button>
          <div class="fade-left"  id="fade-left"  style="opacity:0"></div>
          <div class="track-wrap"><div class="track" id="track"></div></div>
          <div class="fade-right" id="fade-right"></div>
          <button class="arrow right" id="next" aria-label="Scroll right">${this._chevronRight()}</button>
        </div>
      `;
    }
  }

export { ScrollMenu }